/* eslint max-len: ["error", { "code": 120, "tabWidth": 4 }] */
/* eslint-disable node/no-unsupported-features */
import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Info from 'material-ui/svg-icons/action/info';

const NotFound = ({locale}) => (
    <div className="general-main-div">
        <div style={{margin: 'auto'}}>
            <Info style={{display: 'block', margin: '0 auto', width: '100px', height: '100px'}}/>
            <h1 className="article-title-font" style={{textAlign: 'center'}}>404</h1>
            <p style={{textAlign: 'center'}}>{locale.notFound}</p>
        </div>
    </div>
);

NotFound.propTypes = {
    locale: PropTypes.object,
};

const mapStateToProps = (state) => ({
    locale: state.locale.locale,
});

export default connect(
    mapStateToProps
)(NotFound);



// WEBPACK FOOTER //
// ./src/components/NotFound.js